import { queryKeys } from '@terminal/routes/query-params';
import { useSearchParams } from 'react-router';

import { POSTHOG_TRACKING_SOURCES, PosthogTrackingSource } from '../constants';
import { usePostHog } from '../usePostHog';
import { createAlertsEvents } from './alertsEvents';
import { createAlfredEvents } from './alfredEvents';
import { createAlfredMicrosoftConnectionEvents } from './alfredMicrosoftConnectionEvents';
import { createAssetOverviewEvents } from './assetOverviewEvents';
import { createChartEvents } from './chartEvents';
import { createDashboardEvents } from './dashboardEvents';
import { createEventsPageEvents } from './eventsPageEvents';
import { createInsightFeedEvents } from './insightFeedEvents';
import { createInsightsEvents } from './insightsEvents';
import { createNewsEvents } from './newsEvents';
import { createScenarioEvents } from './scenarioEvents';
import { createScreenerEvents } from './screenerEvents';
import { createSearchEvents } from './searchEvents';
import { createSendAllAssetsEvents } from './sendAllAssetsEvents';
import { createThemeEvents } from './themeEvents';
import { createTliEvents } from './tliEvents';
import { createWatchlistEvents } from './watchlistEvents';

export const usePosthogEvents = () => {
  const { captureTrackingEvent } = usePostHog();
  const [searchParams] = useSearchParams();

  const getEmailTrackingParams = () => {
    const utmSource = searchParams.get(queryKeys.utmSource);
    const utmCampaign = searchParams.get(queryKeys.utmCampaign);

    if (utmSource === POSTHOG_TRACKING_SOURCES.EMAIL) {
      return {
        source: POSTHOG_TRACKING_SOURCES.EMAIL as PosthogTrackingSource,
        utm_campaign: utmCampaign,
      };
    }

    return null;
  };

  return {
    ...createAlfredEvents(captureTrackingEvent),
    ...createAlertsEvents(captureTrackingEvent),
    ...createAssetOverviewEvents(captureTrackingEvent),
    ...createChartEvents(captureTrackingEvent),
    ...createDashboardEvents(captureTrackingEvent),
    ...createEventsPageEvents(captureTrackingEvent),
    ...createInsightsEvents(captureTrackingEvent, getEmailTrackingParams),
    ...createNewsEvents(captureTrackingEvent),
    ...createScenarioEvents(captureTrackingEvent),
    ...createScreenerEvents(captureTrackingEvent),
    ...createSearchEvents(captureTrackingEvent),
    ...createSendAllAssetsEvents(captureTrackingEvent),
    ...createInsightFeedEvents(captureTrackingEvent),
    ...createThemeEvents(captureTrackingEvent),
    ...createTliEvents(captureTrackingEvent),
    ...createWatchlistEvents(captureTrackingEvent),
    ...createAlfredMicrosoftConnectionEvents(captureTrackingEvent),
  };
};
